document.addEventListener("DOMContentLoaded", function() {
let slideIndex = 0; // Start with the first set of slides
	const totalSlides = document.getElementsByClassName("myslide").length;
	
showSlides(slideIndex);

// Next/previous controls
 window.plusSlides = function(n) {
      showSlides(slideIndex += n);
    };

function showSlides(n) {
  if (n >= totalSlides - 2) {slideIndex = 0}    
      if (n < 0) {slideIndex = totalSlides - 3}
      
      let wrapper = document.querySelector('.slide-wrapper');
      wrapper.style.transform = `translateX(${-slideIndex * 100 / 3}%)`;
      }
    });